export default {
  delivered: {
    'link-feedback-popup': {
      title: 'Obrigado por usar nosso serviço. Sua opinião é importante para nós.',
      subtitle: 'Deixe uma avaliação na nossa página do Google',
      btn: 'Ok',
    },
    info: {
      'payment-delivered-title': 'Entregue',
    },
    feedback: {
      title: 'Sua opinião é importante para nós',
      comment: {
        title: 'Deixe seus comentários:',
        placeholder: 'Conte se gostou de tudo, quais eram suas expectativas e impressões',
        'send-btn': 'Enviar comentário',
        'change-btn': 'Alterar comentário',
        'not-send-tooltip': {
          text: 'Entrem em contato comigo',
          title: 'O atendimento ao cliente ligará para você',
          content: 'Deixe seu comentário e um agente do nosso atendimento entrará em contato com você em breve.',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': 'Superou as expectativas',
            'professional-appearance': 'Aparência profissional',
            'courteous-and-respectful': 'Cortês e respeitoso',
            'on-time-delivery': 'Entrega no horário',
          },
          negative: {
            'unfriendly-driver': 'Motorista pouco amigável',
            'did-not-follow-instructions': 'Não seguiu as instruções',
            'late-delivery': 'Entrega atrasada',
            'unprofessional-appearance': 'Aparência pouco profissional',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': 'Excelente comunicação',
            'patient-and-understanding': 'Paciente e compreensivo',
            'efficient-coordination': 'Coordenação eficiente',
            'quick-response-time': 'Resposta rápida',
          },
          negative: {
            'impatient-or-rude': 'Impaciente ou grosseiro',
            'poor-coordination': 'Coordenação ruim',
            'failed-to-address-concerns': 'Não resolveu as questões',
            'slow-response-time': 'Resposta lenta',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': 'Equipe atenciosa',
            'secure-packaging': 'Embalagem segura',
            'fast-shipping': 'Envio/renovações rápidos',
            'concise-medication-instructions': 'Instruções do medicamento claras',
          },
          negative: {
            'difficult-to-open': 'Difícil de abrir',
            'incorrect-prescription': 'Receita incorreta',
            'unfriendly-staff': 'Equipe pouco atenciosa',
            'wrong-medication': 'Medicamento errado',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': 'paradas de distância',
      'your-stop-is-next': 'Sua parada é a próxima',
      'special-instruction': {
        title: 'Instruções especiais da farmácia:',
        'new-instruction-input': {
          title: 'Instruções especiais do destinatário',
          placeholder: 'Adicionar instrução especial',
        },
        'new-instruction-btn-save': 'Salvar',
        'not-editable-warning': 'Desculpe, não é possível alterar as instruções especiais porque o motorista já está próximo.',
      },
      'arriving-data': {
        today: {
          'label-2': 'Chega hoje',
          label: 'Previsão de entrega',
        },
        next: {
          label: 'O motorista chegará em',
          time: 'Poucos minutos',
        },
        'few-minutes': {
          'label-2': 'O motorista chegará em',
        },
      },
      qr: {
        info: 'Mostre o código QR ao motorista',
        description: 'Para receber seu pedido, mostre o código QR ao motorista ou informe o código',
        help: 'A coparticipação é um valor fixo em dólares que você precisa pagar por serviços de saúde ou medicamentos cobertos, conforme definido pelo seu plano de saúde.',
      },
    },
    'confirmed-no-route': {
      title: 'Você confirmou a entrega',
      subtitle: 'Aguarde mais informações',
      'for-date': 'para {date}',
    },
    'not-confirmed': {
      form: {
        'empty-title': 'Não se esqueça de assinar',
        'pharmacy-instruction-title': 'Instruções especiais da farmácia:',
        'recipient-instruction': {
          title: 'Instruções especiais do destinatário:',
          placeholder: 'Adicionar instrução especial',
          'update-btn': 'Atualizar',
        },
        sign: {
          description: 'O motorista tentará a entrega presencial. Se não houver ninguém em casa, deixará o pacote na porta e tirará uma foto.',
          confirm: {
            btn: 'Confirmar entrega',
            title: 'Tem certeza?',
            text: 'Confirmo que as informações que forneci são corretas e precisas',
          },
        },
      },
      progress: {
        attempts: 'Tentativa de entrega:',
        created: 'Pedido <br> criado',
      },
      transit: 'Em trânsito',
      'out-for-delivery': 'Saiu para <br> entrega',
      delivered: 'Entregue',
      signature: {
        title: 'Assine abaixo para autorizar a entrega sem assinatura presencial:',
        clear: 'Limpar',
      },
      statuses: {
        'at-pharmacy': 'Seu pedido está na farmácia e será entregue',
        'driver-out': 'Confirme sua entrega',
        rescheduled: 'Entrega reagendada para',
        'pending-back-to-pharmacy': 'Seu pedido aguarda devolução à farmácia',
        'pickup-occured': 'Seu pedido foi retirado na farmácia e será entregue',
      },
    },
    rescheduled: {
      attempted: 'Tentativa em',
    },
  },
  investigation: {
    link_start: 'Entre em contato conosco pelo',
    link_end: 'para agendar uma entrega',
    instructions: 'Instruções especiais da farmácia:',
  },
  rescadule: {
    subtitle: 'Selecione uma nova data de entrega',
    'too-many': 'O pedido não pode ser reagendado mais de 3 vezes. Ligue para {phone}',
    'wrong-address': 'O motorista não conseguiu localizar seu endereço. Informe o endereço correto.',
    'not-present': 'O motorista foi ao seu endereço, mas ninguém atendeu.',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: 'O pedido foi cancelado pela farmácia',
      'pending-back-to-pharmacy': 'Seu pedido foi cancelado e aguarda devolução à farmácia',
      'on-its-way-to-pharmacy': 'Seu pedido foi cancelado e a devolução à farmácia foi confirmada',
      default: 'Seu pedido foi cancelado e devolvido à farmácia',
      'confirmed-back-to-pharmacy': 'Seu pedido foi cancelado; aguardando confirmação de devolução pela farmácia',
      'back-to-pharmacy': 'Seu pedido foi cancelado e devolvido à farmácia',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: 'Seu pedido aguarda devolução à farmácia',
    },
  },
}
